import { Component } from '@angular/core';
import { BlockWordCloud } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-word-cloud',
  templateUrl: './block-wordCloud.component.html',
})
export class BlockWordCloudComponent extends BlockAbstractComponent<BlockWordCloud, null> {
  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(): void {}
}
